import React, { useContext } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import UserContext from "../../services/user/user";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function EPieChart({
  centerTitle,
  data,
  optionsOver,
  title,
  effectiveRevenue,
  isEmpty,
  innerSize = "80%"
}) {
  if (Highcharts.AST) {
    Highcharts.AST.allowedAttributes.push("data-testid");
  }

  const { currency, formatNumber, lang } = useContext(UserContext);

  const theme = useTheme();
  const isTabletScreen = useMediaQuery(theme.breakpoints.between("xs", "md"));

  const options = {
    credits: {
      enabled: false
    },
    chart: {
      type: "pie",
      textAlign: "center",
      height: 300
    },
    title: {
      text: `<span data-testid="revenue_pie_chart_value">${
        isEmpty ? "-" : centerTitle || ""
      }</span>`,
      verticalAlign: "middle",
      align: "center",
      y: 6,
      useHTML: true,
      style: {
        fontFamily: "Inter",
        fontSize: "28px",
        fontWeight: "600",
        lineHeight: "1.1",
        textAlign: "center",
        color: isEmpty
          ? "#b0b0b0"
          : effectiveRevenue > 0
          ? "var(--font-strong-success)"
          : effectiveRevenue < 0
          ? "var(--font-strong-strong-error)"
          : "var(--font-strong-warning)"
      }
    },
    tooltip: {
      headerFormat:
        '<div class="rev-line-table" data-testid="revenue-pie-chart-tooltip">',
      footerFormat: "</div>",
      pointFormatter: function () {
        return `<div style="margin-top: -8px" data-testid="revenue-pie-chart-tooltip-item"><span style="background-color:${
          this.color
        };" class="rev-line-dot" data-testid="revenue-pie-chart-tooltip-dot"></span><div><span style="font-weight: bold" data-testid="revenue-pie-chart-tooltip-series-name">${
          this.name
        }</span> <br /><span data-testid="revenue-pie-chart-tooltip-value">${
          formatNumber(this.y, 0) + currency.symbol
        }</span></div></div>`;
      },
      shared: true,
      useHTML: true,
      style: {
        fontFamily: "Theinhard"
      },
      borderWidth: 0,
      borderRadius: 14,
      backgroundColor: "#ebebeb"
    },

    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false
        }
      }
    },
    legend: {
      useHTML: true,
      align: "center",
      verticalAlign: "bottom",
      y: -16,
      itemMarginBottom: 4,
      itemDistance: -10,
      labelFormatter: function () {
        let labelClass = this.visible
          ? "legend-label-visible"
          : "legend-label-hidden";
        const seriesName = this.name.toLowerCase().replace(/\s+/g, "-");
        return `
    <button aria-label="legend item" class="legend-item ${labelClass}" data-testid="aggregated-last-30-days-${seriesName}">
      <span class="legend-dot" style="background-color: ${this.color};"></span>
      <span class="legend-text">${this.name}</span>
    </button>
  `;
      }
    },
    series: [
      {
        minPointSize: 50,
        innerSize: innerSize,
        borderWidth: 0,
        zMin: 0,
        showInLegend: true,
        data: data,
        states: {
          inactive: {
            opacity: 1
          },
          hover: {
            enabled: false
          }
        }
      }
    ]
  };

  return (
    <div
      style={{
        width: "100%",
        position: "relative",
        opacity: isEmpty && 0.5,
        pointerEvents: isEmpty && "none"
      }}
    >
      <span
        className={`pie-title text ${isEmpty && "text-disabled"}`}
        data-testid="revenue_pie_chart_title"
      >
        {title || ""}
      </span>
      <HighchartsReact
        highcharts={Highcharts}
        options={{ ...options, ...optionsOver }}
      />
    </div>
  );
}
